import React from 'react';
import { useSelector } from 'react-redux';

import { DataSourceSlugs } from 'Shared/constants/types';

import './SuggestionsCalendarDisconnected.scss';

function SuggestionsCalendarDisconnected() {
  const googleSignUpUrl = useSelector(state => {
    const googleCalendarDataSource = state.data_sources.find(
      ({ slug }) => slug === DataSourceSlugs.googleCalendarWorkspaceSync
    );
    return googleCalendarDataSource?.path;
  });
  const office365SignUpUrl = useSelector(state => {
    const office365DataSource = state.data_sources.find(({ slug }) => slug === DataSourceSlugs.office365Calendar);
    return office365DataSource?.path;
  });

  const handleGoogleCalendarClick = () => {
    (window as any).analytics.track('Clicked in Add Workspace Modal', {
      modal: 'add_teammate_or_add_group',
      button: 'Connect Google Calendar',
    });
    window.location.href = googleSignUpUrl;
  };

  const handleOffice365Click = () => {
    (window as any).analytics.track('Clicked in Add Workspace Modal', {
      modal: 'add_teammate_or_add_group',
      button: 'Connect Office365 Calendar',
    });
    window.location.href = office365SignUpUrl;
  };

  return (
    <>
      <div className="add-teammate-sugestions-section-title pb-2">Suggestions:</div>
      <div className="group-suggestions-calendar-disconnected p-2 border border-light">
        Connect&nbsp;
        <a href="#" onClick={handleGoogleCalendarClick}>
          Google Calendar
        </a>
        &nbsp;or&nbsp;
        <a href="#" onClick={handleOffice365Click}>
          Office 365
        </a>
        &nbsp;to create a workspace from your existing calendar meetings
      </div>
    </>
  );
}

export default SuggestionsCalendarDisconnected;
